import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage, plural } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type BulkDeleteMarketShopInventoryRequest = {
  ids: number[]
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const bulkDeleteMarketShopInventory = async (
  data: BulkDeleteMarketShopInventoryRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'delete',
    ...data,
  })
  return response.data
}

export const useBulkDeleteMarketShopInventory = () => {
  return useMutation({
    mutationFn: bulkDeleteMarketShopInventory,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      toastFactory.success(
        `${plural(affected, { one: 'Item', other: 'Items' })} deleted successfully`,
      )
    },
  })
}
